<template>
  <div class="fixed bg-white dark:bg-dark-800 shadow-lg transform transition-transform duration-300 z-[60] border-l border-gray-200 dark:border-dark-600"
    :class="[(isOpen ? drawerTransform[position] : drawerPosition[position]), drawerTransition[position], (isfull ? 'w-full' : 'w-1/2 md:w-96'), ]">
    <!-- Header -->
    <div class="flex items-center justify-between p-4 border-b">
      <h2 class="text-lg font-semibold text-gray-700 dark:text-gray-200">{{ title }}</h2>
      <button @click="$emit('close')" class="p-2 rounded-lg hover:bg-gray-100 transition-colors dark:text-dark-100 dark:hover:bg-dark-800">
        <XMarkIcon class="w-5 h-5" />
      </button>
    </div>

    <!-- Content -->
    <div class="overflow-y-auto h-[calc(100vh-64px)]">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { XMarkIcon } from "@heroicons/vue/24/outline";

export default {
  name: "DrawerPanel",
  components: {
    XMarkIcon,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: "right",
    },
    isfull: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawerPosition: {
        right: "translate-x-full",
        left: "-translate-x-full",
        top: "-translate-y-full",
        bottom: "translate-y-full",
      },
      drawerTransform: {
        right: "translate-x-0",
        left: "-translate-x-0",
        top: "-translate-y-0",
        bottom: "translate-y-0",
      },
      drawerTransition: {
        right: "inset-y-0 right-0",
        left: "inset-y-0 left-0",
        top: "inset-x-0 top-0",
        bottom: "inset-x-0 bottom-0",
      },
    };
  },
  emit: ["close"],
};
</script>
